import React, { Fragment } from 'react'
import { useState, useEffect } from 'react';
import {
  StyledHeader,
  StyledImg,
  StyledButton,
  StyledLink,
  ThemeChangers,
  ThemeChanger,
  StyledMobileNav,
  StyledMobileNavList,
  StyledMobileNavListSecond
} from "./HeaderStyles";

const NavElement = ({iconClose, showNav, setShowNav, allLinks}) => {
    useEffect(() => {
        showNav && ( () => {
            document.querySelector("nav button").focus();
            document.querySelector("header button").blur();
        })();
    }, [showNav])
   const firstSetLinks = allLinks.filter((link, idx, allLinks) => {
     return idx <= Math.floor(allLinks.length / 2) && link;
   });
   const secondSetLinks = allLinks.filter((link, idx) => {
     return idx > Math.floor(allLinks.length / 2) && link;
   });
   return (
     <>
       <StyledMobileNav showNav={showNav}>
         <div className="nav-open-first"></div>
         <nav>
           <div>
             <StyledButton
               onClick={() => {
                 setShowNav((showNav) => {
                   return !showNav;
                 });
               }}
             >
               <StyledImg src={iconClose} alt="" />
             </StyledButton>
           </div>
           <div>
             <StyledMobileNavList>
               {firstSetLinks.map((link) => {
                 return (
                   <li key={link.id}>
                     <StyledLink
                       onClick={() => {
                         setShowNav((showNav) => {
                           return !showNav;
                         });
                       }}
                       to={link.linkPath}
                     >
                       {link.linkName}
                     </StyledLink>
                   </li>
                 );
               })}
             </StyledMobileNavList>
             <StyledMobileNavListSecond>
               {secondSetLinks.map((link) => {
                 return (
                   <li key={link.id}>
                     <StyledLink
                       onClick={() => {
                         setShowNav((showNav) => {
                           return !showNav;
                         });
                       }}
                       to={link.linkPath}
                     >
                       {link.linkName}
                     </StyledLink>
                   </li>
                 );
               })}
             </StyledMobileNavListSecond>
           </div>
         </nav>
       </StyledMobileNav>
     </>
   );
}



// Default Export Header Element
const Header = ({ logo, iconHB, iconClose, theme, toggleTheme, providedTheme, allLinks }) => {
    const [transparent, setTransparent] = useState(false)
    const [themes, setThemes] = useState(theme.themes.map((theme) => { return theme.name === providedTheme ? {...theme, active: true} : theme}))
    const [showNav, setShowNav] = useState(false)
    const toggleActive = (id) => {
        setThemes(themes.map((theme) => {
            return id === theme.id
              ? { ...theme, active: true }
              : { ...theme, active: false };
          })
        );
    };
    useEffect(() => {
      setTimeout(() => {
        transparent === false && setTransparent(true);
      }, 30000);
    }, [transparent]);
    return (
      <>
        <StyledHeader>
          <StyledLink to="/">
            <StyledImg src={logo} alt="hair definition company logo" />
          </StyledLink>
          <StyledButton
            onClick={() => {
              setShowNav((showNav) => {
                return !showNav;
              });
            }}
          >
            <StyledImg src={iconHB} alt="" />
          </StyledButton>
          <NavElement iconClose={iconClose} showNav={showNav} setShowNav={setShowNav} allLinks={allLinks} />
          <ThemeChangers transparent={transparent} onFocus={() => {setTransparent(false)}} onMouseOver ={() => {setTransparent(false)}}>
            {themes.map((theme) => {
              return (
                <ThemeChanger
                  mainColor={theme.mainColor}
                  key={theme.id}
                  active={theme.active}
                  name={theme.name}
                >
                  <StyledButton
                    onClick={() => {
                      toggleTheme(theme.name);
                      toggleActive(theme.id);
                    }}
                  ></StyledButton>
                </ThemeChanger>
              );
            })}
          </ThemeChangers>
        </StyledHeader>
      </>
    );
}
export default Header
